/* Pauses a moving strip ([data-shto-loop]) while it is scrolled out of view. Runs only when a strip enters or leaves
   the screen, never on every frame. Same job as the Month 3 marquee's script: whichever loads first watches every strip. */
(function () {
  if (window.ShtoLoopPause || !('IntersectionObserver' in window)) return;
  window.ShtoLoopPause = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) entry.target.removeAttribute('data-shto-offscreen');
      else entry.target.setAttribute('data-shto-offscreen', '');
    });
  }, { rootMargin: '200px 0px' });
  function watch() { document.querySelectorAll('[data-shto-loop]').forEach(function (el) { window.ShtoLoopPause.observe(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  document.addEventListener('shopify:section:load', watch);
})();
